export class AtivarContaDTO {
  idUsuario: any;
}
